import React, { useEffect, useState } from 'react';
import { investmentPerspectivesAPI } from '../../services/api';

// Month picker for the Investment Perspectives report (keyed by 'YYYY-MM').
// The report only runs from July 2026 — earlier audited months exist in the
// data but never had a portal report, so they're not offered.
const FIRST_PERIOD = '2026-07';

const PeriodSelector = ({ selectedPeriod, onSelectPeriod }) => {
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    investmentPerspectivesAPI.getAvailableMonths()
      .then((result) => {
        const items = (result.months || []).filter((m) => m.value >= FIRST_PERIOD);
        setMonths(items);
        if (!selectedPeriod && items.length > 0) onSelectPeriod(items[0].value);
      })
      .catch((err) => console.error('Error loading available months:', err))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (months.length > 0 && selectedPeriod && !months.find((p) => p.value === selectedPeriod)) {
      onSelectPeriod(months[0].value);
    }
  }, [months, selectedPeriod, onSelectPeriod]);

  return (
    <div className="quarter-selector">
      <h4 className="list-heading">Month</h4>
      <select
        className="quarter-select"
        value={selectedPeriod || ''}
        onChange={(e) => onSelectPeriod(e.target.value)}
        disabled={loading}
      >
        {loading && <option value="">Loading...</option>}
        {months.map((p) => (
          <option key={p.value} value={p.value}>{p.label}</option>
        ))}
      </select>
    </div>
  );
};

export { PeriodSelector };
export default PeriodSelector;
